import React, { useState } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";

const { Text } = Typography;

const AvailableCreditTags = (props) => {
  const { tagName, creditTags, tags, setTags, updateCreditTags } = props;

  console.log(tags);
  console.log(creditTags);

  // const [tags, setTags] = useState([
  //     { id: 1, name: "Suspected Money Laundering", available: true, assigned: false },
  //     { id: 2, name: "Transaction Monitoring", available: true, assigned: false },
  //     { id: 3, name: "Customer Due Deligence", available: true, assigned: false },
  //     { id: 4, name: "Add/Remove Transactions", available: true, assigned: false },
  // ]);

  const handleDebitTagClick = (index) => {
    const updatedTags = [...tags];
    updatedTags[index].available = !updatedTags[index].available;
    updatedTags[index].assigned = !updatedTags[index].assigned;
    setTags(updatedTags);

    const filteredCreditTags = tags
      .filter((tag) => tag.assigned)
      .map((tag) => tag.id);

    creditTags(filteredCreditTags);

    console.log("Filtered: ", filteredCreditTags);
    // console.log("Index: ", index);
  };

  return (
    <div>
      <Row>
        <Col span={9}>
          <Card
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            title={`Available ${tagName} Tags`}
          >
            {tags.map((tag, index) => (
              <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 20,
                  }}
                >
                  <Text>{tag.name}</Text>
                </div>
              </Row>
            ))}
          </Card>
        </Col>
        <Col span={4}>
          <Card style={{ borderRadius: 0 }} title={"Action"}>
            {tags.map((tag, index) => (
              <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 26,
                    marginLeft: "40%",
                    marginRight: "40%",
                  }}
                  onClick={() => handleDebitTagClick(index)}
                >
                  {tag.assigned ? (
                    <ArrowLeftOutlined />
                  ) : (
                    <ArrowRightOutlined />
                  )}
                </div>
              </Row>
            ))}
          </Card>
        </Col>
        <Col span={9}>
          <Card
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            title={`Selected ${tagName} Tags`}
          >
            {tags
              .filter((tag) => tag.assigned)
              .map((tag, index) => (
                <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                  <div
                    style={{
                      borderBottom: "1px solid #f0f0f0",
                      width: "100%",
                      paddingBottom: 20,
                    }}
                  >
                    <Text>{tag.name}</Text>
                  </div>
                </Row>
              ))}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AvailableCreditTags;
